import React, { useMemo } from 'react';
import { useRouter } from 'next/router';

import cn from 'classnames';

import { Icon, IconButton } from 'components';
import { ButtonV3 } from 'components/ComponentV2';
import { Tooltip } from 'components/Tooltip/Tooltip.component';
import { PAGE_ROUTES } from 'lib/page-routes';

import styles from './DashboardHeader.module.scss';

interface DashboardHeaderProps {
  isScrolled: boolean;
  shortUrl: string;
  copyLink: () => void;
  openQRModal: () => void;
  openShortLinkModal: () => void;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = (
  props: DashboardHeaderProps
) => {
  const { isScrolled, shortUrl, copyLink, openQRModal, openShortLinkModal } =
    props;

  const router = useRouter();

  const displayUrl = useMemo(() => {
    return shortUrl.replace('https://', '');
  }, [shortUrl]);

  const tooltipPosition = useMemo(() => {
    return isScrolled ? 'bottom' : 'top';
  }, [isScrolled]);

  const createNewEvent = () => {
    router.push(`${PAGE_ROUTES.EVENTS_CREATE}?step=1&type=Event`);
  };

  return (
    <div
      className={cn(styles.DashboardHeader, {
        [styles.DashboardHeaderScrolled]: isScrolled,
      })}
    >
      <p className={styles.pageTitle}>Dashboard</p>
      <div className={styles.headerAction}>
        <div className={styles.actionPanel}>
          <div className={styles.copyLinkContainer} onClick={copyLink}>
            <Tooltip
              className={styles.actionTooltip}
              childrenClassName={styles.linkContainer}
              content="Click to copy"
              color="dark"
              position={tooltipPosition}
            >
              <Icon iconName="icon_link" size="small" />
              <p className={styles.linkText}>{displayUrl}</p>
            </Tooltip>
          </div>
          <Tooltip
            className={styles.actionTooltip}
            content="Show QR code"
            color="dark"
            position={tooltipPosition}
          >
            <IconButton
              iconName="icon_qrCode"
              className={styles.actionIcon}
              onClick={openQRModal}
            />
          </Tooltip>
          <Tooltip
            className={styles.actionTooltip}
            content="Change link"
            color="dark"
            position={tooltipPosition}
          >
            <IconButton
              iconName="icon_pencil"
              className={styles.actionIcon}
              onClick={openShortLinkModal}
            />
          </Tooltip>
        </div>
        <ButtonV3
          size={isScrolled ? 'small' : 'medium'}
          onClick={createNewEvent}
        >
          Create new event
        </ButtonV3>
      </div>
    </div>
  );
};
